import LoginResult from "./LoginResult";
import Env from "./Env";
import { ApolloClient } from "@apollo/client";
import * as __d3ett from "../rocket/D3ETemplate";
import { D3ETemplate } from "../rocket/D3ETemplate";
import Provider from "../models/Provider";
import Customers from "./Customers";
import Businesses from "./Businesses";
import AdminOrdersRequest from "../models/AdminOrdersRequest";
import GraphQLClientInit from "../utils/GraphQLClientInit";
import LocalDataStore from "../utils/LocalDataStore";
import ServiceCategory from "../models/ServiceCategory";
import AdminOrders from "./AdminOrders";
import ReferenceCatch from "../utils/ReferenceCatch";
import MessageDispatch from "../rocket/MessageDispatch";
import TaxesRequest from "../models/TaxesRequest";
import PortfolioProject from "../models/PortfolioProject";
import Customer from "../models/Customer";
import TaxRate from "../models/TaxRate";
import BusinessesRequest from "../models/BusinessesRequest";
import Taxes from "./Taxes";
import Order from "../models/Order";
import BaseUser from "../models/BaseUser";
import Categories from "./Categories";
import Business from "../models/Business";

export default class Query {
  private _client: ApolloClient<any>;
  private static _queryObject: Query;
  private _referenceCatch: ReferenceCatch;
  private constructor() {}
  private static _init() {
    let q = new Query();

    q._client = GraphQLClientInit.get();

    q._referenceCatch = ReferenceCatch.get();

    return q;
  }
  public static get() {
    if (Query._queryObject == null) {
      Query._queryObject = Query._init();
    }

    return Query._queryObject;
  }
  public async currentUser(): Promise<BaseUser> {
    GraphQLClientInit.token = await LocalDataStore.get().getToken();

    return await LocalDataStore.get().currentUser();
  }
  public async logout(): Promise<boolean> {
    LocalDataStore.get().setUser(null, null);

    await MessageDispatch.get().logout();

    return true;
  }
  public async getPortfolioProjectById(
    usage: number,
    id: number
  ): Promise<PortfolioProject> {
    return MessageDispatch.get().query(__d3ett.PORTFOLIOPROJECT, id, usage);
  }
  public async getProviderById(usage: number, id: number): Promise<Provider> {
    return MessageDispatch.get().query(__d3ett.PROVIDER, id, usage);
  }
  public async getServiceCategoryById(
    usage: number,
    id: number
  ): Promise<ServiceCategory> {
    return MessageDispatch.get().query(__d3ett.SERVICECATEGORY, id, usage);
  }
  public async getTaxRateById(usage: number, id: number): Promise<TaxRate> {
    return MessageDispatch.get().query(__d3ett.TAXRATE, id, usage);
  }
  public async loginAdminUserWithEmailAndPassword(
    usage: number,
    d3eParams?: Partial<{
      email: string;
      password: string;
      deviceToken: string;
    }>
  ): Promise<LoginResult> {
    let email = d3eParams?.email;

    let password = d3eParams?.password;

    let deviceToken = d3eParams?.deviceToken;

    return MessageDispatch.get().login(
      "loginAdminUserWithEmailAndPassword",
      usage,
      { email: email, password: password, deviceToken: deviceToken }
    );
  }
  public async getAdminOrders(
    usage: number,
    request: AdminOrdersRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<AdminOrders> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery(
      "AdminOrders",
      usage,
      true,
      request,
      { synchronize: synchronize }
    );
  }
  public async getBusinesses(
    usage: number,
    request: BusinessesRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<Businesses> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery("Businesses", usage, true, request, {
      synchronize: synchronize,
    });
  }
  public async getCategories(
    usage: number,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<Categories> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery("Categories", usage, false, null, {
      synchronize: synchronize,
    });
  }
  public async getCustomers(
    usage: number,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<Customers> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery("Customers", usage, false, null, {
      synchronize: synchronize,
    });
  }
  public async getTaxes(
    usage: number,
    request: TaxesRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<Taxes> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery("Taxes", usage, true, request, {
      synchronize: synchronize,
    });
  }
}
